import _util from '../../utils/';


const uploadService = {
	commonUpload(posts, resolve, reject) {
		_util.request({
			url: '/api/Common/Upload',
			method: "post",
			data: posts,
			success: resolve,
			error: reject
		})
	},
  uploadPdfFile(posts, resolve, reject) {
    _util.request({
      url: '/api/HROtherAnnouncement/UploadPDF',
      method: "post",
      data: posts,
      success: resolve,
      error: reject
    })
  }
}

export default uploadService;


// WEBPACK FOOTER //
// ./src/services/Common/upload-service.js